import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { GREEN_MAIN, GREEN_LOGO } from '../../../../theme/colors';

interface ConventionedProps {
    approved: boolean; // Valore iniziale passato come prop (true/false)
    resetValue: boolean; // Valore da usare per il reset
    handleChange: (value: string, key: string) => void; // Funzione per aggiornare lo stato
}

const Conventioned: React.FC<ConventionedProps> = ({ approved, resetValue, handleChange }) => { 
    const { t } = useTranslation();

    const [selectedValue, setSelectedValue] = React.useState<boolean>(approved);

    const handleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const boolVal: boolean = value === 'true' ? true : false;  
        setSelectedValue(boolVal);
        handleChange(value, 'conventioned'); 
    };
    
    const handleReset = () => {
        const boolVal: string = resetValue ? 'true' : 'false'; 
        setSelectedValue(resetValue);
        handleChange(boolVal, 'conventioned');
    };

    return (
        <Box 
            sx={{display:'flex'}}
        >
            <TextField
                select
                //label={t('Select approval status')} // Puoi usare la traduzione se necessario
                value={selectedValue.toString()} // Assicuriamoci che il valore sia una stringa
                onChange={handleSelectChange}
                sx={{
                    width: '100%',
                    marginBottom: 0,
                    marginTop: 0,
                    height: '45px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        color: GREEN_MAIN,
                    },
                    '& .MuiSelect-select': {
                        padding: '12px 12px',
                        lineHeight: 1.4,
                        color: "grey",
                        fontSize: '1rem',
                        textTransform: 'none'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: GREEN_LOGO,
                        color: GREEN_MAIN,
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'grey !important',
                    }
                }}
                InputProps={{
                    style: {
                        marginTop: 0,
                        marginBottom: 0,
                    },
                }}
            >
                <MenuItem value="true">{t("Contracted")}</MenuItem>
                <MenuItem value="false">{t("UnContracted")}</MenuItem>
            </TextField>
    
            {/* Bottone per resettare il valore */}
            <Box sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <IconButton onClick={handleReset} sx={{ 
                    width:'45px', 
                    height:'45px',
                    color: GREEN_MAIN
                }}>
                    <ClearIcon />
                </IconButton>
            </Box>
        </Box>
      );
  }

  export default Conventioned;